module.exports = __webpack_public_path__ + "static/media/fa-solid-900.881dc7cf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-solid-900.eot
// module id = 136
// module chunks = 0